
export type PublishCourseDraft200 = {
  /** 게시된 코스 ID */
  courseId?: string;
  /** 게시 결과 메시지 */
  message?: string;
  /** 게시 시간 */
  publishedAt?: string;
  /** 게시 상태 */
  status?: string;
};
